import { render } from "./Mail.svg?vue&type=template&id=52e02c9e"
const script = {}
script.render = render

export default script